/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUploadMiniDto } from '../../models/lexplus-upload-mini-dto';

export interface ArchivierteAnforderungControllerGetArchivierteAnforderungDokumenteV1$Params {
  anforderungsversionID: number;
}

export function archivierteAnforderungControllerGetArchivierteAnforderungDokumenteV1(http: HttpClient, rootUrl: string, params: ArchivierteAnforderungControllerGetArchivierteAnforderungDokumenteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusUploadMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, archivierteAnforderungControllerGetArchivierteAnforderungDokumenteV1.PATH, 'get');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusUploadMiniDto>>;
    })
  );
}

archivierteAnforderungControllerGetArchivierteAnforderungDokumenteV1.PATH = '/v1/compliance/archiv/{anforderungsversionID}/dokumente';
